declare const Highcharts;

/**
 * SeriesPointTooltip: this tooltip contains series and point info.
 */
export class SeriesPointTooltip {
	public static getFormatter(): Function {
		return function (): string {
			if (this.point.tooltip) {
				return this.point.tooltip;
			}
			return '<b>' + this.point.series.name + '</b>' + Highcharts.numberFormat(this.point.y, 2, '.', ',') + '%';
		};
	}
}
